/* unplugin-vue-components disabled */import script from "./NineGridColor.vue?vue&type=script&setup=true&lang=js"
export * from "./NineGridColor.vue?vue&type=script&setup=true&lang=js"

import "./NineGridColor.vue?vue&type=style&index=0&id=5b4d6463&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4d6463"]])

export default __exports__